import { Form, Col, Row, Checkbox } from "antd";

const ConsultationLocation = (props) => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="locations"
      label="Please select your preferred locations for the service"
      rules={[
        {
          required: true,
          message: "Please select at least one location.",
        },
      ]}
    >
      <Checkbox.Group style={{ width: "100%" }}>
        <Row gutter={[0, 8]}>
          {ALL_LOCATIONS.map((loc) => (
            <Col span={12} key={loc}>
              {/* pass the label as children */}
              <Checkbox value={loc} style={{ margin: "0.2rem 0" }}>
                {loc}
              </Checkbox>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    </Form.Item>
  );
};

export default ConsultationLocation;

const ALL_LOCATIONS = [
  "Manukau",
  "Manawa Bay (Airport area)",
  "Newmarket",
  "Britomart",
  "St Lukes",
  "Botany",
  "Hobsonville",
  "Any of the above",
];
